var productId;
class loginPage {
    constructor(){
       this._getCurrentProductName();
    };

    _getCurrentProductName(){
        let urlParams = window.location.search;
        let hash = window.location.hash;
        if(window.location.href.indexOf('?return_url=') >= 0){
          if (urlParams.includes('-handle')) {
            let productHandle = urlParams.replace("?return_url=%2Faccount%3Fproduct-handle%3D", "");
            if(productHandle) {
              document.querySelector("[redirect-from-login]").value= `/products/${productHandle}`;
            }
            else{
              const urlParams = new URLSearchParams(window.location.search);
              document.querySelector("[redirect-from-login]").value= urlParams.get('return_url');
            }
          }
          else{
            let productId = urlParams.replace("?return_url=%2Faccount%3Fproduct-id%3D","");
            console.log(productId,'id')
            if(!isNaN(parseInt(productId))) {
              document.querySelector("[redirect-from-login]").value= `/pages/survey?product-id=${productId}${hash}`;
            } else {
                const urlParams = new URLSearchParams(window.location.search + window.location.hash);
                document.querySelector("[redirect-from-login]").value= urlParams.get('return_url');
            }
          }
        }
    }
}
new loginPage()
